import React from 'react';
import {Button} from "@mui/material";
import {useStyles} from "./AppbarActionButton.css";

const AppbarActionButton = ({label, icon, ...props}) => {
    const classes = useStyles();

    return (
        <div>
            <Button variant="outlined" className={classes.button} {...props}>
                <div className={classes.extendedIcon}>
                    {icon}
                </div>
                {label}
            </Button>
        </div>
    )
}

export default AppbarActionButton
